// @flow weak

import {
  REQUEST, SUCCESS,
  FAILURE, UPDATE_REQUEST,
  UPDATE_SUCCESS, UPDATE_FAILURE,
  CREATE_REQUEST, CREATE_SUCCESS,
  CREATE_FAILURE, VARIANT_UPDATE_REQUEST,
  VARIANT_UPDATE_SUCCESS, VARIANT_UPDATE_FAILURE,
  SET_ACTIVE_VARIANT,
  VARIANT_IMAGE, VARIANT_IMAGE_UPLOADED, SET_DEFAULT_VARIANT_IMAGE,
  TOGGLE_REPLACEMENT_DIALOG, REPLACEMENT_PRODUCTS_REQUEST,
  REPLACEMENT_PRODUCTS_SUCCESS, REPLACEMENT_PRODUCTS_FAILURE,
  REPLACEMENT_VARIANTS_REQUEST, REPLACEMENT_VARIANTS_SUCCESS,
  REPLACEMENT_VARIANTS_FAILURE, CLEAR, REMOVE_VARIANT_IMAGE,
  SET_ACTIVE_VARIANT_IMAGE, SUPPLIERS_REQUEST,
  SUPPLIERS_SUCCESS, SUPPLIERS_FAILURE,
  RESET, ROOM_TYPES_REQUEST, FILTER_ARCHIVED,
  ROOM_TYPES_SUCCESS, ROOM_TYPES_FAILURE,
  SET_RELATED_PRODUCT_TYPE, RELATED_PRODUCT_TOGGLE,
  RELATED_PRODUCT_TYPE_TOGGLE, ADD_RELATED_PRODUCT_TYPE_REQUEST,
  ADD_RELATED_PRODUCT_TYPE_SUCCESS, ADD_RELATED_PRODUCT_TYPE_FAILURE,
  RELATED_PRODUCT_SELECTED, RELATED_VARIANT_SELECTED,
  WORKER_TYPES_REQUEST, WORKER_TYPES_SUCCESS, WORKER_TYPES_FAILURE,
  PRODUCT_TYPES_REQUEST, PRODUCT_TYPES_SUCCESS, PRODUCT_TYPES_FAILURE,
  SET_SHARED_RELATED_PRODUCT_TYPE, SHARED_RELATED_PRODUCT_TOGGLE,
  SHARED_RELATED_PRODUCT_TYPE_TOGGLE, ADD_SHARED_RELATED_PRODUCT_TYPE_SUCCESS,
  SHARED_RELATED_PRODUCT_SELECTED, SHARED_RELATED_VARIANT_SELECTED,
  VARIANTS_UPDATE_REQUEST, VARIANTS_UPDATE_FAILURE,
  VARIANTS_UPDATE_SUCCESS, RELATED_PRODUCT_TYPE_SELECTED,
  SHARED_RELATED_PRODUCT_TYPE_SELECTED, REMOVE_PRODUCT_TYPE,
  SHARED_REMOVE_PRODUCT_TYPE, UNLOCK_SHARED,
  ADDITIONAL_PRODUCTS_REQUEST, ADDITIONAL_PRODUCTS_SUCCESS,
  ADDITIONAL_PRODUCTS_FAILURE, ADDITIONAL_VARIANTS_REQUEST,
  ADDITIONAL_VARIANTS_SUCCESS, ADDITIONAL_VARIANTS_FAILURE,
  SET_ACTIVE_VARIANT_LINKED_ADDITIONAL_VARIANT, REMOVE_VARIANT_LINKED_ADDITIONAL_VARIANT,
  ADD_VARIANT_LINKED_ADDITIONAL_VARIANT, UPDATE_VARIANT_LINKED_ADDITIONAL_VARIANT,
  SET_ACTIVE_PRODUCT_LINKED_ADDITIONAL_VARIANT, REMOVE_PRODUCT_LINKED_ADDITIONAL_VARIANT,
  ADD_PRODUCT_LINKED_ADDITIONAL_VARIANT, UPDATE_PRODUCT_LINKED_ADDITIONAL_VARIANT,
} from '../actions/productView';
import {SET_DIRTY} from '../actions/form';
import _ from 'lodash/fp';
import {combineReducers} from 'redux';

const defaultProductState = {
  filteredVariants: [],
  includeArchived: false,
  isDirty: false,
  isFetching: false,
  error: null,
  active: null,
  variants: [],
  linkedAdditionalVariants: [],
  relatedProductType: null,
};

const sortByItemNumber = _.sortBy('itemNumber');

const notArchived = _.filter({archived: null});

const filterVariants = (variants, mainVariantId) => {
  let filtered = notArchived(variants);
  const main = _.find({id: mainVariantId}, variants);

  if (main && !_.some({id: mainVariantId}, filtered)) {
    filtered = sortByItemNumber([
      ...filtered,
      main,
    ]);
  }

  return filtered;
};

const product = (state = defaultProductState, action) => {
  switch (action.type) {
    case FILTER_ARCHIVED:
      return {
        ...state,
        includeArchived: action.includeArchived,
      };
    case REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
        active: null,
        variants: [],
      };
    case SUCCESS:
    case CREATE_SUCCESS: {
      const variants = sortByItemNumber(action.variants);
      return {
        ...state,
        isDirty: false,
        isFetching: false,
        error: null,
        active: action.product,
        filteredVariants: filterVariants(variants, action.product.mainVariantId),
        variants,
        linkedAdditionalVariants: action.product.linkedAdditionalVariants,
        relatedProductType: null,
      };
    }
    case FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case UPDATE_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case UPDATE_SUCCESS:
      return {
        ...state,
        filteredVariants: filterVariants(sortByItemNumber(state.variants), action.product.mainVariantId),
        isDirty: false,
        isFetching: false,
        error: null,
        active: action.product,
        linkedAdditionalVariants: action.product.linkedAdditionalVariants,
      };
    case UPDATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case CREATE_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case VARIANT_UPDATE_SUCCESS: {
      const {variant} = action;
      const variants = sortByItemNumber([
        ..._.filter(v => v.id !== variant.id, state.variants),
        variant,
      ]);
      return {
        ...state,
        filteredVariants: state.active ? filterVariants(variants, state.active.mainVariantId) : variants,
        variants,
        relatedProductType: null,
      };
    }
    case VARIANTS_UPDATE_SUCCESS: {
      const variants = sortByItemNumber(action.variants);
      return {
        ...state,
        filteredVariants: state.active ? filterVariants(variants, state.active.mainVariantId) : variants,
        variants,
        relatedProductType: null,
      };
    }
    case SET_DIRTY:
      return {
        ...state,
        isDirty: action.form === 'product'
          ? action.dirty
          : state.isDirty,
      };
    case SET_SHARED_RELATED_PRODUCT_TYPE:
      return {
        ...state,
        relatedProductType: action.relatedProductType,
      };
    case ADD_SHARED_RELATED_PRODUCT_TYPE_SUCCESS:
      return {
        ...state,
        relatedProductType: !!state.relatedProductType
          && action.productType.id === state.relatedProductType.id
          ? null
          : state.relatedProductType,
      };
    case ADD_PRODUCT_LINKED_ADDITIONAL_VARIANT:
      return {
        ...state,
        linkedAdditionalVariants: [
          ...state.linkedAdditionalVariants,
          action.additional,
        ],
      };
    case REMOVE_PRODUCT_LINKED_ADDITIONAL_VARIANT:
      return {
        ...state,
        linkedAdditionalVariants: _.filter(a => a.productVariant.id !== action.additional.productVariant.id, state.linkedAdditionalVariants),
      };
    case UPDATE_PRODUCT_LINKED_ADDITIONAL_VARIANT:
      return {
        ...state,
        linkedAdditionalVariants: [
          ..._.filter(a => a.productVariant.id !== action.additional.productVariant.id, state.linkedAdditionalVariants),
          action.additional,
        ],
      };
    case RESET:
      return {
        ...state,
        linkedAdditionalVariants: state.active ? state.active.linkedAdditionalVariants : [],
        isDirty: false,
        relatedProductType: null,
      };
    case CLEAR:
      return defaultProductState;
    default:
      return state;
  }
};

const filterPartialSelected =
  _.filter(v => v.selected !== false);

const getSelectedVariantCount = _.flow(
  _.flatMap('variants'),
  filterPartialSelected,
  _.get('length'),
);

const countVariants =
  _.sumBy(p => p.variants.length);

const getRelated = (existingState = {}, variant) => {
  const related = variant && variant.related
    ? _.groupBy('productTypeId', variant.related)
    : {};
  const existing = !!variant ? existingState[variant.id] : null;
  return _.map(id => {
    const productTypeId = _.toNumber(id);
    const existingType = !!existing ? _.find({id: productTypeId}, existing) : null;
    const productGroup = _.groupBy('productId', related[id]);
    const products = _.map(pKey => {
      const productId = _.toNumber(pKey);
      const existingProduct = !!existingType ? _.find({id: productId}, existingType.products) : null;
      const variants = _.map(v => ({
        id: v.id,
        name: v.name,
        itemNumber: v.itemNumber,
        selected: v.selected,
      }), productGroup[pKey]);
      const fullSelectedCount = _.filter('selected', variants).length;
      const partialSelectedCount = filterPartialSelected(variants).length;
      return {
        id: productId,
        name: productGroup[pKey][0].productName,
        mainVariantId: productGroup[pKey][0].mainVariantId,
        variants,
        opened: !!existingProduct ? existingProduct.opened : false,
        selected: fullSelectedCount === variants.length
          ? true
          : partialSelectedCount === 0
            ? false
            : null,
      };
    }, _.keys(productGroup));
    const selectedCount = getSelectedVariantCount(products);
    return {
      id: productTypeId,
      name: related[id][0].productTypeName,
      products,
      opened: !!existingType ? existingType.opened : false,
      selectedCount,
      selected: selectedCount === 0
        ? false
        : products.length === _.filter('selected', products).length
          ? true
          : null,
    };
  }, _.keys(related));
};

const getFullRelated = (variants, existingState = {}) =>
  _.flow(
    notArchived,
    _.keyBy('id'),
    _.mapValues(_.partial(getRelated, [existingState])),
  )(variants);

const getSharedRelated = (variants, existingState = []) => {
  const variantCount = _.keys(variants).length;
  const grouped = _.flow(
    _.flatMap(_.values),
    _.groupBy('id'),
  )(variants);
  return _.map(key => {
    const group = grouped[key];
    const {name} = group[0];
    const id = _.toNumber(key);
    const existingType = _.find({id}, existingState);
    const groupedProducts = _.flow(
      _.flatMap('products'),
      _.groupBy('id'),
    )(group);
    const products = _.map(pKey => {
      const productGroup = groupedProducts[pKey];
      const {
        mainVariantId,
        name: productName,
      } = productGroup[0];
      const id = _.toNumber(pKey);
      const existingProduct = !!existingType ? _.find({id}, existingType.products) : null;
      const groupedVariants = _.flow(
        _.flatMap('variants'),
        _.groupBy('id'),
      )(productGroup);
      const mappedVariants = _.map(vKey => {
        const variantGroup = groupedVariants[vKey];
        const {
          name: variantName,
          itemNumber: variantItemNumber,
        } = variantGroup[0];
        const selectedCount = _.filter('selected', variantGroup).length;
        return {
          id: _.toNumber(vKey),
          name: variantName,
          itemNumber: variantItemNumber,
          selected: selectedCount === variantCount
            ? true
            : selectedCount === 0
              ? false
              : null,
        };
      }, _.keys(groupedVariants));
      const fullSelectedCount = _.filter('selected', mappedVariants).length;
      const partialSelectedCount = filterPartialSelected(mappedVariants).length;
      return {
        id,
        mainVariantId,
        name: productName,
        opened: !!existingProduct ? existingProduct.opened : false,
        selected: fullSelectedCount === mappedVariants.length
          ? true
          : partialSelectedCount === 0
            ? false
            : null,
        variants: mappedVariants,
      };
    }, _.keys(groupedProducts));
    const selectedCount = getSelectedVariantCount(products);
    return {
      id,
      name,
      products,
      opened: !!existingType ? existingType.opened : false,
      selectedCount,
      selected: selectedCount === 0
        ? false
        : products.length === _.filter('selected', products).length
          ? true
          : null,
    };
  }, _.keys(grouped));
};

const hasVariantDiffs = (shared, list) => {
  const values = _.values(list);
  return _.some(({id, selected, products}) =>
    _.some(typeList => {
      const typeMatch = _.find({id, selected}, typeList);
      return !typeMatch
        || _.some(({id, selected, variants}) => {
          const prodMatch = _.find({id, selected}, typeMatch.products);
          return !prodMatch
            || _.some(({id, selected}) =>
              !_.find({id, selected}, prodMatch.variants), variants
            );
        }, products);
    }, values), shared);
};

const defaultVariantState = {
  isDirty: false,
  isFetching: false,
  error: null,
  active: null,
  activeImage: null,
  linkedAdditionalVariants: [],
  images: [],
  relatedProductType: null,
  related: {
    error: null,
    isFetching: false,
    list: {},
    shared: [],
    hasVariantDiffs: false,
  },
  uploads: {},
};

const variant = (state = {}, action) => {
  switch (action.type) {
    case SUCCESS:
    case CREATE_SUCCESS: {
      const main = _.find({
        id: action.variantId || action.product.mainVariantId,
      }, action.variants);
      const newRelatedState = getFullRelated(action.variants, state.variant.related.list);
      const shared = getSharedRelated(newRelatedState);
      return {
        ...state.variant,
        isDirty: false,
        active: main,
        related: {
          ...state.variant.related,
          list: newRelatedState,
          shared,
          hasVariantDiffs: hasVariantDiffs(shared, newRelatedState),
        },
        relatedProductType: null,
        images: main && main.images ? [
          ...main.images,
        ] : [],
        linkedAdditionalVariants: main && main.linkedAdditionalVariants ? [
          ...main.linkedAdditionalVariants,
        ] : [],
        uploads: {},
      };
    }
    case VARIANT_UPDATE_REQUEST:
      return {
        ...state.variant,
        isFetching: true,
        error: null,
      };
    case VARIANT_UPDATE_SUCCESS: {
      const {variant} = action;
      const newRelatedState = {
        ...state.variant.related.list,
        [variant.id]: getRelated(state.variant.related.list, variant),
      };
      const shared = getSharedRelated(newRelatedState, state.variant.related.shared);
      return {
        ...state.variant,
        isDirty: false,
        isFetching: false,
        error: null,
        active: variant,
        related: {
          ...state.variant.related,
          list: newRelatedState,
          shared,
          hasVariantDiffs: !!state.variant.related.hasVariantDiffs
            ? hasVariantDiffs(shared, newRelatedState)
            : state.variant.related.hasVariantDiffs,
        },
        relatedProductType: null,
        images: variant && variant.images ? [
          ...variant.images,
        ] : [],
        linkedAdditionalVariants: variant && variant.linkedAdditionalVariants ? [
          ...variant.linkedAdditionalVariants,
        ] : [],
      };
    }
    case VARIANT_UPDATE_FAILURE:
      return {
        ...state.variant,
        isFetching: false,
        error: action.error,
      };
    case VARIANTS_UPDATE_REQUEST:
      return {
        ...state.variant,
        isFetching: true,
        error: null,
      };
    case VARIANTS_UPDATE_SUCCESS: {
      const main = _.find({
        id: !!state.variant.active
          ? state.variant.active.id
          : state.product.active.mainVariantId,
      }, action.variants);
      const newRelatedState = getFullRelated(action.variants, state.variant.related.list);
      const shared = getSharedRelated(newRelatedState, state.variant.related.shared);
      return {
        ...state.variant,
        isDirty: false,
        isFetching: false,
        active: main,
        related: {
          ...state.variant.related,
          list: newRelatedState,
          shared,
          hasVariantDiffs: !!state.variant.related.hasVariantDiffs
            ? hasVariantDiffs(shared, newRelatedState)
            : state.variant.related.hasVariantDiffs,
        },
        relatedProductType: null,
        images: main && main.images ? [
          ...main.images,
        ] : [],
        linkedAdditionalVariants: main && main.linkedAdditionalVariants ? [
          ...main.linkedAdditionalVariants,
        ] : [],
        error: null,
      };
    }
    case VARIANTS_UPDATE_FAILURE:
      return {
        ...state.variant,
        isFetching: false,
        error: action.error,
      };
    case SET_ACTIVE_VARIANT:
      return {
        ...state.variant,
        active: action.variant,
        activeImage: null,
        relatedProductType: null,
        images: action.variant && action.variant.images ? [
          ...action.variant.images,
        ] : [],
        linkedAdditionalVariants: action.variant && action.variant.linkedAdditionalVariants ? [
          ...action.variant.linkedAdditionalVariants,
        ] : [],
        uploads: {},
      };
    case VARIANT_IMAGE: {
      const existing = state.variant.uploads[action.variantId] || [];
      return {
        ...state.variant,
        uploads: {
          ...state.variant.uploads,
          [action.variantId]: [
            ...existing,
            action.tempId,
          ],
        },
      };
    }
    case REMOVE_VARIANT_IMAGE:
      if (action.isTemp) {
        const existing = state.variant.uploads[action.variantId] || [];
        return {
          ...state.variant,
          uploads: {
            ...state.variant.uploads,
            [action.variantId]: _.filter(i => i !== action.imageId, existing),
          },
        };
      } else if (state.variant.active && state.variant.active.id === action.variantId) {
        return {
          ...state.variant,
          images: _.filter(i => i.id !== action.imageId, state.variant.images),
        };
      }

      return state.variant;
    case VARIANT_IMAGE_UPLOADED:
      if ((state.variant.active && state.variant.active.id === action.variantId)
        || (!state.variant.active && action.variantId === 0)) {
        return {
          ...state.variant,
          images: [
            ...state.variant.images,
            action.metadata,
          ],
        };
      }

      return state.variant;
    case SET_DEFAULT_VARIANT_IMAGE:
      return {
        ...state.variant,
        activeImage: state.variant.activeImage ? {
          ...state.variant.activeImage,
          isDefault: state.variant.activeImage.id === action.image.id,
        } : null,
        images: _.map(image => ({
          ...image,
          isDefault: image.id === action.image.id,
        }), state.variant.images),
      };
    case SET_ACTIVE_VARIANT_IMAGE:
      return {
        ...state.variant,
        activeImage: action.image,
      };
    case ADD_VARIANT_LINKED_ADDITIONAL_VARIANT:
      return {
        ...state.variant,
        linkedAdditionalVariants: [
          ...state.variant.linkedAdditionalVariants,
          action.additional,
        ],
      };
    case REMOVE_VARIANT_LINKED_ADDITIONAL_VARIANT:
      return {
        ...state.variant,
        linkedAdditionalVariants: _.filter(a => a.productVariant.id !== action.additional.productVariant.id, state.variant.linkedAdditionalVariants),
      };
    case UPDATE_VARIANT_LINKED_ADDITIONAL_VARIANT:
      return {
        ...state.variant,
        linkedAdditionalVariants: [
          ..._.filter(a => a.productVariant.id !== action.additional.productVariant.id, state.variant.linkedAdditionalVariants),
          action.additional,
        ],
      };
    case RESET: {
      const newRelatedState = getFullRelated(state.product.variants, state.variant.related.list);
      const shared = getSharedRelated(newRelatedState);
      return {
        ...state.variant,
        isDirty: false,
        activeImage: null,
        related: {
          ...state.variant.related,
          list: newRelatedState,
          shared,
          hasVariantDiffs: hasVariantDiffs(shared, newRelatedState),
        },
        relatedProductType: null,
        images: state.variant.active && state.variant.active.images ? [
          ...state.variant.active.images,
        ] : [],
        linkedAdditionalVariants: state.variant.active && state.variant.active.linkedAdditionalVariants ? [
          ...state.variant.active.linkedAdditionalVariants,
        ] : [],
        uploads: {},
      };
    }
    case SET_DIRTY:
      return {
        ...state.variant,
        isDirty: action.form === 'productVariant'
          ? action.dirty
          : state.variant.isDirty,
      };
    case CLEAR:
      return defaultVariantState;
    case SET_RELATED_PRODUCT_TYPE:
      return {
        ...state.variant,
        relatedProductType: action.relatedProductType,
      };
    case ADD_RELATED_PRODUCT_TYPE_REQUEST:
      return {
        ...state.variant,
        related: {
          ...state.variant.related,
          isFetching: true,
        },
      };
    case ADD_RELATED_PRODUCT_TYPE_SUCCESS: {
      const variantProductTypes = state.variant.related.list[action.variantId] || [];
      const newRelatedState = _.some({id: action.productType.id}, variantProductTypes)
        ? state.variant.related.list
        : {
          ...state.variant.related.list,
          [action.variantId]: [
            ...variantProductTypes,
            (() => {
              const products = _.flow(
                notArchived,
                _.map(p => ({
                  id: p.id,
                  name: p.name,
                  opened: false,
                  selected: true,
                  variants: _.flow(
                    notArchived,
                    _.map(v => ({
                      id: v.id,
                      name: v.name,
                      itemNumber: v.itemNumber,
                      selected: true,
                    }))
                  )(p.variants),
                })),
                _.filter(p => !!p.variants.length),
              )(action.products);
              return {
                id: action.productType.id,
                name: action.productType.name,
                opened: false,
                selectedCount: countVariants(products),
                products,
                selected: !!products.length,
              };
            })(),
          ],
        };
      const shared = getSharedRelated(newRelatedState, state.variant.related.shared);
      return {
        ...state.variant,
        relatedProductType: !!state.variant.relatedProductType
          && action.productType.id === state.variant.relatedProductType.id
          ? null
          : state.variant.relatedProductType,
        related: {
          ...state.variant.related,
          error: null,
          isFetching: false,
          list: newRelatedState,
          shared,
          hasVariantDiffs: hasVariantDiffs(shared, newRelatedState),
        },
      };
    }
    case ADD_RELATED_PRODUCT_TYPE_FAILURE:
      return {
        ...state.variant,
        related: {
          ...state.variant.related,
          error: action.error,
          isFetching: false,
        },
      };
    case RELATED_PRODUCT_SELECTED: {
      const newRelatedState = {
        ...state.variant.related.list,
        [action.variantId]: _.map(t => {
          const products = _.map(p => ({
            ...p,
            selected: p.id === action.id ? action.selected : p.selected,
            variants: p.id === action.id ? _.map(v => ({
              ...v,
              selected: action.selected,
            }), p.variants) : p.variants,
          }), t.products);
          const selectedCount = getSelectedVariantCount(products);
          return ({
            ...t,
            products,
            selectedCount,
            selected: selectedCount === 0
              ? false
              : products.length === _.filter('selected', products).length
                ? true
                : null,
          });
        }, state.variant.related.list[action.variantId] || []),
      };
      const shared = getSharedRelated(newRelatedState, state.variant.related.shared);
      return {
        ...state.variant,
        related: {
          ...state.variant.related,
          list: newRelatedState,
          shared,
          hasVariantDiffs: hasVariantDiffs(shared, newRelatedState),
        },
      };
    }
    case RELATED_VARIANT_SELECTED: {
      const newRelatedState = {
        ...state.variant.related.list,
        [action.variantId]: _.map(t => {
          const products = _.map(p => {
            const variants = _.map(v => ({
              ...v,
              selected: v.id === action.id ? action.selected : v.selected,
            }), p.variants);
            const selectedCount = _.filter('selected', variants).length;
            return {
              ...p,
              variants,
              selected: selectedCount === 0
                ? false
                : selectedCount === variants.length
                  ? true
                  : null,
            };
          }, t.products);
          const selectedCount = getSelectedVariantCount(products);
          return {
            ...t,
            products,
            selectedCount,
            selected: selectedCount === 0
              ? false
              : products.length === _.filter('selected', products).length
                ? true
                : null,
          };
        }, state.variant.related.list[action.variantId] || []),
      };
      const shared = getSharedRelated(newRelatedState, state.variant.related.shared);
      return {
        ...state.variant,
        related: {
          ...state.variant.related,
          list: newRelatedState,
          shared,
          hasVariantDiffs: hasVariantDiffs(shared, newRelatedState),
        },
      };
    }
    case RELATED_PRODUCT_TOGGLE:
      return {
        ...state.variant,
        related: {
          ...state.variant.related,
          list: {
            ...state.variant.related.list,
            [action.variantId]: _.map(t => ({
              ...t,
              products: _.map(p => ({
                ...p,
                opened: p.id === action.id ? !p.opened : p.opened,
              }), t.products),
            }), state.variant.related.list[action.variantId] || []),
          },
        },
      };
    case RELATED_PRODUCT_TYPE_TOGGLE:
      return {
        ...state.variant,
        related: {
          ...state.variant.related,
          list: {
            ...state.variant.related.list,
            [action.variantId]: _.map(t => ({
              ...t,
              opened: t.id === action.id ? !t.opened : t.opened,
            }), state.variant.related.list[action.variantId] || []),
          },
        },
      };
    case ADD_SHARED_RELATED_PRODUCT_TYPE_SUCCESS: {
      const newRelatedState = _.mapValues(v =>
        _.some({id: action.productType.id}, v)
          ? v
          : [
            ...v,
            (() => {
              const products = _.flow(
                notArchived,
                _.map(p => ({
                  id: p.id,
                  name: p.name,
                  mainVariantId: p.mainVariantId,
                  opened: false,
                  selected: true,
                  variants: _.flow(
                    notArchived,
                    _.map(v => ({
                      id: v.id,
                      name: v.name,
                      itemNumber: v.itemNumber,
                      selected: true,
                    }))
                  )(p.variants),
                })),
                _.filter(p => !!p.variants.length),
              )(action.products);
              return {
                id: action.productType.id,
                name: action.productType.name,
                opened: false,
                selectedCount: countVariants(products),
                products,
                selected: !!products.length,
              };
            })(),
          ], state.variant.related.list);
      const shared = getSharedRelated(newRelatedState, state.variant.related.shared);
      return {
        ...state.variant,
        relatedProductType: !!state.variant.relatedProductType
          && action.productType.id === state.variant.relatedProductType.id
          ? null
          : state.variant.relatedProductType,
        related: {
          ...state.variant.related,
          error: null,
          isFetching: false,
          list: newRelatedState,
          shared,
          hasVariantDiffs: hasVariantDiffs(shared, newRelatedState),
        },
      };
    }
    case SHARED_RELATED_PRODUCT_SELECTED: {
      const newRelatedState = _.mapValues(x =>
        _.some({id: action.productType.id}, x)
          ? _.map(t => {
            const products = _.map(p => ({
              ...p,
              selected: p.id === action.id ? action.selected : p.selected,
              variants: p.id === action.id ? _.map(v => ({
                ...v,
                selected: action.selected,
              }), p.variants) : p.variants,
            }), t.products);
            const selectedCount = getSelectedVariantCount(products);
            return ({
              ...t,
              products,
              selectedCount,
              selected: selectedCount === 0
                ? false
                : products.length === _.filter('selected', products).length
                  ? true
                  : null,
            });
          }, x)
          : [
            ...x,
            (() => {
              const products = _.flow(
                notArchived,
                _.map(p => ({
                  id: p.id,
                  name: p.name,
                  opened: false,
                  selected: p.id === action.id,
                  variants: _.flow(
                    notArchived,
                    _.map(v => ({
                      id: v.id,
                      name: v.name,
                      itemNumber: v.itemNumber,
                      selected: p.id === action.id,
                    })),
                  )(p.variants),
                })),
                _.filter(p => !!p.variants.length),
              )(action.products);
              const selectedCount = _.flow(
                _.filter({id: action.id}),
                _.sumBy(p => p.variants.length),
              )(products);
              return {
                id: action.productType.id,
                name: action.productType.name,
                opened: false,
                products,
                selectedCount,
                selected: selectedCount === 0
                  ? false
                  : products.length === _.filter('selected', products).length
                    ? true
                    : null,
              };
            })(),
          ], state.variant.related.list);
      return {
        ...state.variant,
        related: {
          ...state.variant.related,
          error: null,
          isFetching: false,
          list: newRelatedState,
          shared: getSharedRelated(newRelatedState, state.variant.related.shared),
        },
      };
    }
    case SHARED_RELATED_VARIANT_SELECTED: {
      const newRelatedState = _.mapValues(x =>
        _.some({id: action.productType.id}, x)
          ? _.map(t => {
            const products = _.map(p => {
              const variants = _.map(v => ({
                ...v,
                selected: v.id === action.id ? action.selected : v.selected,
              }), p.variants);
              const selectedCount = _.filter('selected', variants).length;
              return {
                ...p,
                variants,
                selected: selectedCount === 0
                  ? false
                  : selectedCount === variants.length
                    ? true
                    : null,
              };
            }, t.products);
            const selectedCount = getSelectedVariantCount(products);
            return {
              ...t,
              products,
              selectedCount,
              selected: selectedCount === 0
                ? false
                : products.length === _.filter('selected', products).length
                  ? true
                  : null,
            };
          }, x)
          : [
            ...x,
            (() => {
              const products = _.flow(
                notArchived,
                _.map(p => {
                  const variants = _.flow(
                    notArchived,
                    _.map(v => ({
                      id: v.id,
                      name: v.name,
                      itemNumber: v.itemNumber,
                      selected: v.id === action.id ? action.selected : v.selected,
                    })),
                  )(p.variants);
                  const selectedCount = filterPartialSelected(variants).length;
                  return {
                    id: p.id,
                    name: p.name,
                    opened: false,
                    selected: selectedCount === variants.length
                      ? true
                      : selectedCount === 0
                        ? false
                        : null,
                    variants,
                  };
                }),
                _.filter(p => !!p.variants.length),
              )(action.products);
              const selectedCount = getSelectedVariantCount(products);
              return {
                id: action.productType.id,
                name: action.productType.name,
                opened: false,
                products,
                selectedCount,
                selected: selectedCount === 0
                  ? false
                  : products.length === _.filter('selected', products).length
                    ? true
                    : null,
              };
            })(),
          ], state.variant.related.list);
      return {
        ...state.variant,
        related: {
          ...state.variant.related,
          error: null,
          isFetching: false,
          list: newRelatedState,
          shared: getSharedRelated(newRelatedState, state.variant.related.shared),
        },
      };
    }
    case SHARED_RELATED_PRODUCT_TOGGLE:
      return {
        ...state.variant,
        related: {
          ...state.variant.related,
          shared: _.map(t => ({
            ...t,
            products: _.map(p => ({
              ...p,
              opened: p.id === action.id ? !p.opened : p.opened,
            }), t.products),
          }), state.variant.related.shared),
        },
      };
    case SHARED_RELATED_PRODUCT_TYPE_TOGGLE:
      return {
        ...state.variant,
        related: {
          ...state.variant.related,
          shared: _.map(t => ({
            ...t,
            opened: t.id === action.id ? !t.opened : t.opened,
          }), state.variant.related.shared),
        },
      };
    case RELATED_PRODUCT_TYPE_SELECTED: {
      const newRelatedState = {
        ...state.variant.related.list,
        [action.variantId]: _.map(t => {
          if (t.id !== action.id) {
            return t;
          }
          const products = _.map(p => ({
            ...p,
            selected: !!action.selected,
            variants: _.map(v => ({
              ...v,
              selected: !!action.selected,
            }), p.variants),
          }), t.products);
          const selectedCount = getSelectedVariantCount(products);
          return ({
            ...t,
            products,
            selectedCount,
            selected: selectedCount === 0
              ? false
              : products.length === _.filter('selected', products).length
                ? true
                : null,
          });
        }, state.variant.related.list[action.variantId] || []),
      };
      const shared = getSharedRelated(newRelatedState, state.variant.related.shared);
      return {
        ...state.variant,
        related: {
          ...state.variant.related,
          list: newRelatedState,
          shared,
          hasVariantDiffs: hasVariantDiffs(shared, newRelatedState),
        },
      };
    }
    case SHARED_RELATED_PRODUCT_TYPE_SELECTED: {
      const newRelatedState = _.mapValues(x =>
        _.some({id: action.productType.id}, x)
          ? _.map(t => {
            if (t.id !== action.productType.id) {
              return t;
            }
            const products = _.map(p => ({
              ...p,
              selected: action.selected,
              variants: _.map(v => ({
                ...v,
                selected: action.selected,
              }), p.variants),
            }), t.products);
            return ({
              ...t,
              products,
              selectedCount: countVariants(products),
              selected: !!action.selected ? !!products.length : false,
            });
          }, x)
          : [
            ...x,
            (() => {
              const products = _.flow(
                notArchived,
                _.map(p => ({
                  id: p.id,
                  name: p.name,
                  opened: false,
                  selected: !!action.selected,
                  variants: _.flow(
                    notArchived,
                    _.map(v => ({
                      id: v.id,
                      name: v.name,
                      itemNumber: v.itemNumber,
                      selected: !!action.selected,
                    })),
                  )(p.variants),
                })),
                _.filter(p => !!p.variants.length),
              )(action.products);
              return {
                id: action.productType.id,
                name: action.productType.name,
                opened: false,
                selectedCount: !!action.selected
                  ? countVariants(products)
                  : 0,
                products,
                selected: !!action.selected ? !!products.length : false,
              };
            })(),
          ], state.variant.related.list);
      return {
        ...state.variant,
        related: {
          ...state.variant.related,
          error: null,
          isFetching: false,
          list: newRelatedState,
          shared: getSharedRelated(newRelatedState, state.variant.related.shared),
        },
      };
    }
    case REMOVE_PRODUCT_TYPE: {
      const newRelatedState = {
        ...state.variant.related.list,
        [action.variantId]: _.reject({id: action.id}, state.variant.related.list[action.variantId] || []),
      };
      const shared = getSharedRelated(newRelatedState, state.variant.related.shared);
      return {
        ...state.variant,
        related: {
          ...state.variant.related,
          list: newRelatedState,
          shared,
          hasVariantDiffs: hasVariantDiffs(shared, newRelatedState),
        },
      };
    }
    case SHARED_REMOVE_PRODUCT_TYPE: {
      const newRelatedState = _.mapValues(
        _.reject({id: action.id}),
        state.variant.related.list,
      );
      return {
        ...state.variant,
        related: {
          ...state.variant.related,
          list: newRelatedState,
          shared: getSharedRelated(newRelatedState, state.variant.related.shared),
        },
      };
    }
    case UNLOCK_SHARED:
      return {
        ...state.variant,
        related: {
          ...state.variant.related,
          hasVariantDiffs: false,
        },
      };
    default:
      return state.variant;
  }
};

const replacementVisibility = (state = false, action) => {
  switch (action.type) {
    case TOGGLE_REPLACEMENT_DIALOG:
      return !!action.show;
    default:
      return state;
  }
};

const defaultReplacementProductsState = {
  isFetching: false,
  error: null,
  list: [],
};

const replacementProducts = (state = defaultReplacementProductsState, action) => {
  switch (action.type) {
    case REPLACEMENT_PRODUCTS_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
        list: [],
      };
    case REPLACEMENT_PRODUCTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        list: action.products,
      };
    case REPLACEMENT_PRODUCTS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case CLEAR:
      return defaultReplacementProductsState;
    default:
      return state;
  }
};

const defaultReplacementVariantsState = {
  isFetching: false,
  error: null,
  list: [],
};

const replacementVariants = (state = defaultReplacementVariantsState, action) => {
  switch (action.type) {
    case REPLACEMENT_PRODUCTS_REQUEST:
      return {
        ...state,
        list: [],
      };
    case REPLACEMENT_VARIANTS_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
        list: [],
      };
    case REPLACEMENT_VARIANTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        list: action.variants,
      };
    case REPLACEMENT_VARIANTS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case CLEAR:
      return defaultReplacementVariantsState;
    default:
      return state;
  }
};

const activeVariantLinkedAdditionalVariant = (state = null, action) => {
  switch (action.type) {
    case SET_ACTIVE_PRODUCT_LINKED_ADDITIONAL_VARIANT:
      return null;
    case SET_ACTIVE_VARIANT_LINKED_ADDITIONAL_VARIANT:
      return action.additional;
    default:
      return state;
  }
};

const activeProductLinkedAdditionalVariant = (state = null, action) => {
  switch (action.type) {
    case SET_ACTIVE_PRODUCT_LINKED_ADDITIONAL_VARIANT:
      return action.additional;
    case SET_ACTIVE_VARIANT_LINKED_ADDITIONAL_VARIANT:
      return null;
    default:
      return state;
  }
};

const defaultAdditionalProductsState = {
  isFetching: false,
  error: null,
  list: [],
};

const additionalProducts = (state = defaultAdditionalProductsState, action) => {
  switch (action.type) {
    case ADDITIONAL_PRODUCTS_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
        list: [],
      };
    case ADDITIONAL_PRODUCTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        list: action.products,
      };
    case ADDITIONAL_PRODUCTS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case CLEAR:
      return defaultAdditionalProductsState;
    default:
      return state;
  }
};

const defaultAdditionalVariantsState = {
  isFetching: false,
  error: null,
  list: [],
};

const additionalVariants = (state = defaultAdditionalVariantsState, action) => {
  switch (action.type) {
    case ADDITIONAL_PRODUCTS_REQUEST:
      return {
        ...state,
        list: [],
      };
    case ADDITIONAL_VARIANTS_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
        list: [],
      };
    case ADDITIONAL_VARIANTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        list: action.variants,
      };
    case ADDITIONAL_VARIANTS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case CLEAR:
      return defaultAdditionalVariantsState;
    default:
      return state;
  }
};

const includeId = id =>
  _.filter(t => t.id === id || !t.archived);

const filterSuppliers = product =>
  product && !!product.supplierId
    ? includeId(product.supplierId)
    : notArchived;

const defaultSupplierState = {
  list: [],
  filteredList: [],
  error: null,
  isFetching: false,
};

const suppliers = (state = {}, action) => {
  switch (action.type) {
    case SUPPLIERS_REQUEST:
      return {
        ...defaultSupplierState,
        isFetching: true,
      };
    case SUPPLIERS_FAILURE:
      return {
        ...state.suppliers,
        error: action.error,
        isFetching: false,
      };
    case SUPPLIERS_SUCCESS:
      return {
        ...defaultSupplierState,
        list: action.suppliers,
        filteredList: filterSuppliers(state.product.active)(action.suppliers),
      };
    default:
      return state.suppliers;
  }
};

const roomTypesList = (state = [], action) => {
  switch (action.type) {
    case ROOM_TYPES_SUCCESS:
      return notArchived(action.roomTypes);
    case ROOM_TYPES_REQUEST:
    case CLEAR:
      return [];
    default:
      return state;
  }
};

const roomTypesIsFetching = (state = false, action) => {
  switch (action.type) {
    case ROOM_TYPES_REQUEST:
      return true;
    case ROOM_TYPES_SUCCESS:
    case ROOM_TYPES_FAILURE:
    case CLEAR:
      return false;
    default:
      return state;
  }
};

const roomTypesError = (state = null, action) => {
  switch (action.type) {
    case ROOM_TYPES_FAILURE:
      return action.error;
    case ROOM_TYPES_REQUEST:
    case ROOM_TYPES_SUCCESS:
    case CLEAR:
      return null;
    default:
      return state;
  }
};

const roomTypes = combineReducers({
  list: roomTypesList,
  error: roomTypesError,
  isFetching: roomTypesIsFetching,
});

const workerTypesList = (state = [], action) => {
  switch (action.type) {
    case WORKER_TYPES_SUCCESS:
      return notArchived(action.workerTypes);
    case WORKER_TYPES_REQUEST:
    case CLEAR:
      return [];
    default:
      return state;
  }
};

const workerTypesIsFetching = (state = false, action) => {
  switch (action.type) {
    case WORKER_TYPES_REQUEST:
      return true;
    case WORKER_TYPES_SUCCESS:
    case WORKER_TYPES_FAILURE:
    case CLEAR:
      return false;
    default:
      return state;
  }
};

const workerTypesError = (state = null, action) => {
  switch (action.type) {
    case WORKER_TYPES_FAILURE:
      return action.error;
    case WORKER_TYPES_REQUEST:
    case WORKER_TYPES_SUCCESS:
    case CLEAR:
      return null;
    default:
      return state;
  }
};

const workerTypes = combineReducers({
  list: workerTypesList,
  error: workerTypesError,
  isFetching: workerTypesIsFetching,
});

const filterProductTypes = product =>
  product
    ? includeId(product.productTypeId)
    : notArchived;

const filterRelated = (product, related) =>
  _.flow(
    notArchived,
    !!product ? _.filter(t => t.id !== product.productTypeId) : _.identity,
    !_.isEmpty(related) ? _.filter(t => !_.some({id: t.id}, related)) : _.identity,
  );

const defaultProductTypesState = {
  list: [],
  filteredList: [],
  relatedList: [],
  error: null,
  isFetching: false,
  sharedRelatedList: [],
};

const productTypes = (state = {}, action) => {
  switch (action.type) {
    case PRODUCT_TYPES_REQUEST:
      return {
        ...defaultProductTypesState,
        isFetching: true,
      };
    case PRODUCT_TYPES_FAILURE:
      return {
        ...state.productTypes,
        error: action.error,
        isFetching: false,
      };
    case PRODUCT_TYPES_SUCCESS:
      return {
        ...defaultProductTypesState,
        list: action.productTypes,
        relatedList: !!state.variant.active
          ? filterRelated(
            state.product.active,
            state.variant.related.list[state.variant.active.id],
          )(action.productTypes)
          : [],
        filteredList: filterProductTypes(state.product.active)(action.productTypes),
        sharedRelatedList: filterRelated(state.product.active, state.variant.related.shared)(action.productTypes),
      };
    case SUCCESS:
    case VARIANT_UPDATE_SUCCESS:
    case SET_ACTIVE_VARIANT:
    case RESET:
    case ADD_RELATED_PRODUCT_TYPE_SUCCESS:
    case ADD_SHARED_RELATED_PRODUCT_TYPE_SUCCESS:
    case RELATED_PRODUCT_TYPE_TOGGLE:
    case SHARED_RELATED_PRODUCT_TYPE_TOGGLE:
    case REMOVE_PRODUCT_TYPE:
    case SHARED_REMOVE_PRODUCT_TYPE:
    case VARIANTS_UPDATE_SUCCESS:
      return {
        ...state.productTypes,
        relatedList: !!state.variant.active
          ? filterRelated(
            state.product.active,
            state.variant.related.list[state.variant.active.id],
          )(state.productTypes.list)
          : [],
        sharedRelatedList: filterRelated(state.product.active, state.variant.related.shared)(state.productTypes.list),
      };
    default:
      return state.productTypes;
  }
};

const reducers = combineReducers({
  product,
  variant: (s = defaultVariantState) => s,
  suppliers: (s = defaultSupplierState) => s,
  roomTypes,
  workerTypes,
  productTypes: (s = defaultProductTypesState) => s,
  replacement: combineReducers({
    show: replacementVisibility,
    products: replacementProducts,
    variants: replacementVariants,
  }),
  activeProductLinkedAdditionalVariant,
  activeVariantLinkedAdditionalVariant,
  linkedAdditionalVariantDialog: combineReducers({
    products: additionalProducts,
    variants: additionalVariants,
  }),
});

const productView = (state, action) => {
  const newState = reducers(state, action);
  const withVariantState = {
    ...newState,
    variant: variant(newState, action),
  };
  return {
    ...withVariantState,
    suppliers: suppliers(withVariantState, action),
    productTypes: productTypes(withVariantState, action),
  };
};

export default productView;



// WEBPACK FOOTER //
// ./src/reducers/productView.js